import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    agent: null,
    role: null,
    BaseWsUrl: 'wss://api.shibuya24.com',
    // BaseWsUrl: 'ws://127.0.0.1:4020',
    WsChat: null,
    WsMain: null,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_AGENT(state, val) {
      state.agent = val;
    },
    SET_ROLE(state, val) {
      state.role = val;
    },
    SET_WSMAIN(state, val) {
      state.WsMain = val;
    },
    SET_WSCHAT(state, val) {
      state.WsChat = val;
    },
    
  },
  actions: {},
}
